import { useEffect, useSyncExternalStore } from 'react'
import { TOAST_VISIBLE_MS, getToastState, hideToast, subscribeToast } from '../../lib/toast'

/** Paints the current toast (lib/toast.ts) with the prototype's `toast()`
 * styling: fixed 24px from the bottom, centred, `--text-primary` background
 * on `--bg-card` text, 10px 18px, 8px radius, 13px/500, 0.2s fade. Rendered
 * once, by AppShell. */
export function Toaster() {
  const current = useSyncExternalStore(subscribeToast, getToastState, getToastState)

  useEffect(() => {
    if (!current.visible) return
    const timer = setTimeout(hideToast, TOAST_VISIBLE_MS)
    return () => clearTimeout(timer)
  }, [current.seq, current.visible])

  // Nothing in the DOM until the first toast; after that the element stays so
  // the fade-out can run.
  if (current.message === '') return null
  return (
    <output
      aria-live="polite"
      className={`block fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none bg-[var(--text-primary)] text-[var(--bg-card)] px-[18px] py-2.5 rounded-lg text-[13px] font-medium shadow-[0_6px_20px_rgba(0,0,0,.25)] transition-opacity duration-200 ${
        current.visible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {current.message}
    </output>
  )
}
